import { useEffect } from "react";

/**
 * Hard navigation out of the SPA, e.g. to a LiveView route that is not
 * handled by react-router. Replaces the history entry so the back button
 * does not bounce the user back into the redirecting route.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};

export default ExternalRedirect;
